/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import {  translation } from 'plugin/liferay-widgets-react-web';

import { FormControl } from 'external/react-bootstrap';

import {FliwasFormGrid, FliwasFormGroup, FliwasFormHeading } from '../components/BasicFormComponents';
import * as FormValidationUtil from '../utils/form-validation-util';


const validate = formData => {
    let titleValid;

    titleValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 75, 'Titel');

    return {
        title: titleValid
    };
};

class CriticalObjectEditForm extends React.Component {
    constructor(props) {
        super(props);
         this.props.onChange(this.props.formData, validate(this.props.formData));
    }

    handleChange(field, e) {
        this.change(field, e.target.value);
    }

    change(field, value) {

        const formData = this.props.formData,
            item = formData.item || formData;

        const newData = {
            ...item,
            [ field ]: value
        };

        this.props.onChange(newData, validate(newData));
    }

    render() {
        const { formData, formValidation } = this.props;

        return (
            <FliwasFormGrid>
                <FliwasFormHeading title={'Benannte Liste bearbeiten'}/>

                <FliwasFormGroup title={translation.trans('title')}
                                 formValidation={formValidation}
                                 propName={'title'}
                                 required>
                    <FormControl type="text"
                                 required
                                 placeholder={translation.trans('title')}
                                 value={formData && formData.title ? formData.title : ''}
                                 onChange={this.handleChange.bind(this, 'title')}/>
                </FliwasFormGroup>

            </FliwasFormGrid>
        );
    }
}

CriticalObjectEditForm.propTypes = {
    formData: PropTypes.object,
    drawOptions: PropTypes.object,
    handleGeometryChange: PropTypes.func,
    onChange: PropTypes.func,
    formValidation: PropTypes.object
};

export default CriticalObjectEditForm;



// WEBPACK FOOTER //
// ./js/components/NamedListEditForm.jsx